module.exports = __webpack_public_path__ + "img/ejm.d9909143.png";